import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareF = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler6') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler6', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Dpic/ring!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Dpic/ring!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareF}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareF
  
